/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown>, reps: NonNullable<unknown> }} Exercise_Sheet_Set_Load_RepsInputs */

const en_us2_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_br2_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const es_419_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const pt_pt2_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const fr_fr2_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const de_de2_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

const it_it2_exercise_sheet_set_load_reps = /** @type {(inputs: Exercise_Sheet_Set_Load_RepsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.loadText} × ${i?.reps}`)
};

/**
* | output |
* | --- |
* | "{loadText} × {reps}" |
*
* @param {Exercise_Sheet_Set_Load_RepsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_set_load_reps = /** @type {((inputs: Exercise_Sheet_Set_Load_RepsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Set_Load_RepsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_set_load_reps(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_set_load_reps(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_set_load_reps(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_set_load_reps(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_set_load_reps(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_set_load_reps(inputs)
	return en_us2_exercise_sheet_set_load_reps(inputs)
});
export { exercise_sheet_set_load_reps as "exercise-sheet.set_load_reps" }